import { render, staticRenderFns } from "./SilenceApproval.vue?vue&type=template&id=4ac06066&scoped=true"
import script from "./SilenceApproval.vue?vue&type=script&lang=js"
export * from "./SilenceApproval.vue?vue&type=script&lang=js"
import style0 from "./SilenceApproval.vue?vue&type=style&index=0&id=4ac06066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac06066",
  null
  
)

export default component.exports